<script>
import VTooltipWrapper from "../../common/v-tooltip-wrapper.vue";

export default {
    name: "element-trigger-icon",
    components: {VTooltipWrapper},
    props: {
        trigger: {},
        invertColors: Boolean,
    },
    computed: {
        isActive() {
            if (!this.trigger) return false;
            if (Array.isArray(this.trigger)) return this.trigger.length > 0;
            if (_.isString(this.trigger)) return this.trigger.trim().length > 0;

            return false;
        },
        tooltipText() {
            if (Array.isArray(this.trigger) && this.trigger.length)
                return `Triggers: ${this.trigger.join(", ")}`;
            if (_.isString(this.trigger) && this.trigger.trim())
                return this.trigger;
            return "Has no trigger assigned";
        },
        activeClass() {
            if (this.invertColors) return 'fa-solid fa-bolt icon-is-inactive';
            return 'fa-solid fa-bolt icon-is-active';
        },
        inactiveClass() {
            if (this.invertColors) return 'fa-light fa-bolt icon-is-inactive';
            return 'fa-solid fa-bolt icon-is-inactive';
        }
    },
}
</script>

<template>
    <v-tooltip-wrapper :open-delay="350">
        <template #activator="{ on, attrs }">
            <div
                class="element-icon-outer-container"
                v-bind="attrs"
                v-on="on"
            >
                <i v-if="isActive" :class="activeClass"/>
                <i v-else :class="inactiveClass"/>
            </div>
        </template>

        <div class="simple-icon-tooltip">
            {{ tooltipText }}
        </div>
    </v-tooltip-wrapper>
</template>

<style scoped>
.icon-is-inactive,
.icon-is-active {
    transition: color 0.3s ease;
}

.icon-is-inactive {
    color: var(--color-easescreen-primary);
}

.icon-is-active {
    color: white;
}
</style>
